

















import Vue from "vue";
import { mapState } from "vuex";
import { Computed, Data, Method, Props } from "./formTypes";

export default Vue.extend<Data, Method, Computed, Props>({
  name: "vc-cancel-survey-form",

  data() {
    return {
      isError: false,
      errorMessage: ""
    };
  },
  computed: {
    ...mapState("cancelSurveyForm", ["results", "resultCount"]),
    isDisabledConfirmButton: function(): boolean {
      const resultKeys = Object.keys(this.results);
      for (const key of resultKeys) {
        const result = this.results[parseInt(key)];
        // 特定の「その他」のみ未入力の場合ボタンを非アクティブにする
        if (result.choiceId === 10 && result.additionalComment == "") {
          return true;
        }
      }

      return this.resultCount !== this.questions.length;
    }
  },
  props: {
    returnUrl: { default: "" },
    caption: { default: "" },
    questions: { default: [] }
  },
  methods: {
    async onClickConfirm() {
      // 画面遷移を一度挟むため、localStorageに保存する
      localStorage.cancelSurveyResults = JSON.stringify(
        this.results,
        undefined,
        1
      );
      window.location.href = this.returnUrl;
    },

    getConfirmButtonColorClass(): string {
      return this.isDisabledConfirmButton
        ? "cancelSurvey__confirmButton--disabled"
        : "cancelSurvey__confirmButton";
    }
  }
});
